// extracted by mini-css-extract-plugin
export default {"FeePlan":"FeePlan_FeePlan__wKqQQ"};